import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { UserSearchFieldComponent } from 'src/app/components/user-search-field/user-search-field.component';
import {
  AliasDirective,
  ApplyPurePipe,
  ErrorResultComponent,
  GenericSelectComponent,
  HasFullErrorPipe,
  SplitStringPipe,
  ToStringPipe,
} from 'src/app/lego-utils';

/**
 * The declarables EMMET's templates used to get from `LEGOEngineeringAngularUtilsModule`.
 */
@NgModule({
  declarations: [
    AliasDirective,
    ApplyPurePipe,
    ErrorResultComponent,
    GenericSelectComponent,
    HasFullErrorPipe,
    SplitStringPipe,
    ToStringPipe,
    UserSearchFieldComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NzAvatarModule,
    NzCollapseModule,
    NzGridModule,
    NzIconModule,
    NzResultModule,
    NzSelectModule,
    ReactiveFormsModule,
  ],
  exports: [
    AliasDirective,
    ApplyPurePipe,
    ErrorResultComponent,
    GenericSelectComponent,
    HasFullErrorPipe,
    SplitStringPipe,
    ToStringPipe,
    UserSearchFieldComponent,
  ],
})
export class LegoUtilsModule {}
